import ServicesCard from "../components/cards/ServicesCard";
import Navigation from "../components/layout/Navigation";
import { TabTitle } from "../utils/helperFunctions";

function Services() {
  TabTitle("Services");

  //Services to map through
  let services = [
    {
      img: "img/clients/ss&b2.webp",
      name: "Maintenance of Websites",
      key: "Assistance with updates to your project",
      key2: "Solutions for outdated code",
      key3: "Consultations for your project",
      href: "https://ssbhc.com",
    },
    {
      img: "img/clients/pagespeed_insights.webp",
      name: "Website Page Analysis & Improvements",
      key: "Improve Web Pages Performance Speeds",
      key2: "Search Engine Optimization testing",
      key3: "Accessability, Best Practices Assessment & Fixes",
      href: "https://pagespeed.web.dev",
    },
    {
      img: "img/clients/sanitystudio.webp",
      name: "Set up of CMS through Sanity Studio.IO",
      key: "Initial Setup and configuration with a compatible project",
      key2: "Maintenance of the studio",
      key3: "Explanation and advice of what you can do with the studio",
      href: "https://www.sanity.io",
    },
    // {
    //   img: "img/clients/maw_portfolio.webp",
    //   name: "Small Website Architecture & Configuration ",
    //   key: "Integration with Sanity Studio",
    //   key2: "Hosting & Domain set up",
    //   key3: "Site Implementation & Design",
    //   href: "https://www.mwportfolio.online",
    // },
    {
      img: "img/clients/fisher.webp",
      name: "Web Design & Minor Graphic Design",
      key: "New Designs & Re Designs",
      key2: "Creation of Logos",
      key3: "Consultations on Web builders",
      href: "https://www.fisherprotectionservices.com/",
    },

    // End Contracts
  ];
  return (
    <div
      className="ui row"
      style={{
        backgroundColor: "black",
      }}
    >
      <Navigation />
      <div className="ui container fluid">
        <div className="ui items">
          {services.map((service) => (
            <ServicesCard data={service} />
          ))}
        </div>
        <h1 className="ui horizontal inverted divider">Contact Information</h1>
      </div>
      <div className="ui container">
        <div className="ui two column stackable grid very relaxed padded">
          <div className="ui column ">
            <a href={"/contact"} target="_blank" rel="noreferrer">
              <img
                className="ui image large centered rounded myLogo"
                id="serviceImage"
                alt={"my logo"}
                src={"/img/logo.webp"}
                style={{ width: "450px",  }}
              />
            </a>
          </div>
          <div
            className="ui column center aligned relaxed"
            style={{ alignSelf: "center" }}
          >
            <div className="content">
              <span className="ui text huge" style={{ color: "gold" }}>
                Michael Wilson
              </span>
              <div className="ui list huge relaxed " style={{ color: "white" }}>
                <div className="item">
                  <a
                    href="tel:+1417-509-9354"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Reach out to us at 417-509-9354"
                    style={{ color: "white" }}
                  >
                    417-509-9354
                  </a>
                </div>
                <div className="item">
                  {" "}
                  <a
                    href="mailto:mawwebservicesllc@gmail.com"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Email us at - mawwebservicesllc@gmail.com"
                    style={{ color: "white" }}
                  >
                    mawwebservicesllc@gmail.com
                  </a>
                </div>
                <div className="item">Springfield, MO</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
